Prelogin = (function (prelogin) {
    prelogin.Login = {};
    const self = prelogin.Login;

    self.init = function () {
        $('#password, #password-confirm').on(
            'keyup',
            _.debounce(() => {
                const password = $('#password').val();
                const passwordConfirm = $('#password-confirm').val();

                if (password !== passwordConfirm && passwordConfirm !== '') {
                    $('.match-warning').removeClass('hidden');
                } else {
                    $('.match-warning').addClass('hidden');
                }
            }, 500),
        );

        $('#reset-password').on('keydown submit', (e) => {
            if (e.keyCode === 13 || e.keyCode === 32) {
                openPasswordReset(e);
            }
        });

        $('#reset-password').on('click', (e) => {
            openPasswordReset(e);
        });

        const activateLenny = function (whichFace) {
            const lennyBox = $('#lenny');

            if (lennyBox.data('animating') === false && lennyBox.data('which-face') === '') {
                lennyBox.data('animating', true);
                lennyBox.data('which-face', whichFace);

                lennyShow(whichFace);

                switch (whichFace) {
                    case 'normal':
                        lennyPupilsBig();
                        break;
                    case 'smile':
                        lennyEyebrowsUp();
                        break;
                    case 'worried':
                        lennyPupilsLeft();
                        break;
                    default:
                        break;
                }
            }
        };

        let lennyEyebrowsUp = function () {
            const eyebrow1 = $('#lenny-smile').find('#smile-eyebrow1');
            const eyebrow2 = $('#lenny-smile').find('#smile-eyebrow2');

            gsap.to(eyebrow1, {
                y: '-7',
                duration: 0.5,
                ease: Elastic.out,
                delay: 1,
                onComplete() {
                    gsap.to(eyebrow1, { y: '0', duration: 1.5, ease: Power3.in });
                },
            });
            gsap.to(eyebrow2, {
                y: '-5',
                duration: 0.5,
                ease: Elastic.out,
                delay: 1,
                onComplete() {
                    gsap.to(eyebrow2, { y: '0', duration: 1.5, ease: Power3.in });
                },
            });
        };

        let lennyPupilsBig = function () {
            const pupil1 = $('#lenny-normal').find('#normal-pupil1');
            const pupil2 = $('#lenny-normal').find('#normal-pupil2');

            gsap.to(pupil1, {
                scale: 1.25,
                duration: 0.75,
                svgOrigin: '60.583 90',
                ease: 'slow',
                delay: 1.5,
                onComplete() {
                    gsap.to(pupil1, { scale: 1, duration: 2.5, ease: Power3.out });
                },
            });
            gsap.to(pupil2, {
                scale: 1.25,
                duration: 0.75,
                svgOrigin: '182 90',
                ease: 'slow',
                delay: 1.5,
                onComplete() {
                    gsap.to(pupil2, { scale: 1, duration: 2.5, ease: Power3.out });
                },
            });
        };

        let lennyPupilsLeft = function () {
            const pupil1 = $('#lenny-worried').find('#worried-pupil1');
            const pupil2 = $('#lenny-worried').find('#worried-pupil2');

            gsap.to(pupil1, {
                x: '-10',
                duration: 2.5,
                delay: 1,
                svgOrigin: '65.66 89.79',
                ease: Power3.in,
                onComplete() {
                    gsap.to(pupil1, { x: '0', duration: 1, ease: 'rough' });
                },
            });
            gsap.to(pupil2, {
                x: '-20',
                duration: 2.5,
                delay: 1,
                svgOrigin: '176.02 89.79',
                ease: Power3.in,
                onComplete() {
                    gsap.to(pupil2, { x: '0', duration: 1, ease: 'rough' });
                },
            });
        };

        let lennyShow = function (whichFace) {
            const lennyBox = $('#lenny');
            const lennyFace = lennyBox.find(`.${whichFace}`);

            gsap.fromTo(
                lennyFace,
                1.5,
                { y: '0' },
                {
                    y: '-250',
                    ease: Power1.out,
                    onComplete() {
                        gsap.to(lennyFace, 1, { y: '0', delay: 3, ease: Power1.in });
                        lennyBox.data('animating', false);
                        lennyBox.data('which-face', '');
                    },
                },
            );
        };

        const openPasswordReset = function (e) {
            e.preventDefault();
            $('.reset-error').addClass('hidden');
            $('.notice-card').removeClass('hidden');

            const resetUrl = $('#reset-password').data('reset-url');
            VjsUtility.Popup.init({
                iconType: 'fa',
                // Inlined from js/templates/prelogin/reset-password.html;
                // runtime Handlebars.compile() trips the CSP 'unsafe-eval'
                // restriction.
                content: `
                    <span class="reset-instructions">Please enter your email for instructions to reset your password.</span>
                    <form id="password-reset-form" class="form-horizontal email-reset" action="${resetUrl}" method="post">
                        <label for="user-email" class="control-label">Email</label>
                        <input type="email" class="form-control" id="user-email" placeholder="Email">
                        <button class="btn btn-success">Submit</button>
                    </form>
                    <p class="reset-error invalid-email hidden">Email is not valid. Please try again.</p>
                    <div class="reset-error email-not-found hidden">
                        <p>
                            The email address you entered was not found in our system. Therefore, we are unable to send you instructions for
                            accessing Pathful Junior.
                        </p>
                        <p>
                            You must contact your teacher or site administrator to retrieve your username/password.
                        </p>
                    </div>
                    <div class="reset-error validation-sent hidden">
                        <h2>Validate Email! Please Read:</h2>
                        <p>
                            <i class="fa-regular fa-square-check" aria-hidden="true"></i>Instructions for validating your email will be sent to you shortly.
                        </p>
                        <p>
                            <i class="fa-regular fa-square-check" aria-hidden="true"></i>If you do not receive the validation email in a few minutes, please be sure to check your spam or junk folder.
                        </p>
                        <p>
                            <i class="fa-regular fa-square-check" aria-hidden="true"></i>If the email is still not in your inbox or junk/spam folder, please contact your IT professional to ensure that @vjsjunior.com is on your whitelist and is being allowed through the firewall.
                        </p>
                        <p>
                            <i class="fa-regular fa-square-check" aria-hidden="true"></i>Once you've validated your email, please fill out the forgot password form again.
                        </p>
                    </div>
                    <div class="reset-error send-failed hidden">
                        <p>
                            We were unable to send the email. Please try again in a few minutes.
                        </p>
                        <p>
                            If the problem continues, contact your teacher or site administrator.
                        </p>
                    </div>
                    <div class="reset-success hidden">
                        <h2>Success! Please Read:</h2>
                        <p>
                            <i class="fa-regular fa-square-check" aria-hidden="true"></i>Instructions for resetting your password will be emailed to you shortly.
                        </p>
                        <p>
                            <i class="fa-regular fa-square-check" aria-hidden="true"></i>If you do not receive the reset password email in a few minutes, please be sure to check your spam or junk folder.
                        </p>
                        <p>
                            <i class="fa-regular fa-square-check" aria-hidden="true"></i>If the email is still not in your inbox or junk/spam folder, please contact your IT professional to ensure that
                            @vjsjunior.com is on your whitelist and is being allowed through the firewall.
                        </p>
                    </div>
                    <div class="notice-card">
                        <p>
                            Note: If you do not have an email address validated with your account, you must contact your teacher/site administrator for retrieval of your login credentials.
                        </p>
                    </div>
                `,
                hideTitle: true,
                bodyClasses: 'no-title reset-password-dialog',
                width: '400px',
                after() {
                    $('#password-reset-form').submit((submitEvent) => {
                        submitEvent.preventDefault();
                        const submitUrl = $('#reset-password').data('reset-url');
                        const license = $('#reset-password').data('license');
                        const userEmail = $('#user-email').val();

                        if (userEmail === '' || userEmail == null) {
                            return;
                        }

                        const responseFaces = {
                            'email-not-found': 'worried',
                            'invalid-email': 'worried',
                            'reset-instructions': 'normal',
                            'validation-sent': 'normal',
                            'send-failed': 'worried',
                            'reset-success': 'smile',
                        };

                        // Shows one message under the form, which stays open so the user
                        // can try another address.
                        const showFormMessage = (messageClass) => {
                            $('.email-not-found, .validation-sent, .send-failed, .invalid-email, .reset-success, .notice-card').addClass(
                                'hidden',
                            );
                            $('#password-reset-form, .reset-instructions').removeClass('hidden');
                            $(`.${messageClass}`).removeClass('hidden');

                            activateLenny(responseFaces[messageClass]);
                        };

                        const submit = new VjsUtility.Request();
                        submit
                            .post(submitUrl, { user_email: userEmail, license })
                            .done((response) => {
                                if (response && response.data && response.data.notice === 'validation-sent') {
                                    showFormMessage('validation-sent');
                                    return;
                                }

                                $(
                                    '.notice-card, .invalid-email, .reset-instructions, .email-not-found, .validation-sent, .send-failed, #password-reset-form',
                                ).addClass('hidden');
                                $('.reset-success').removeClass('hidden');

                                activateLenny('smile');
                            })
                            .fail((error) => {
                                // Unexpected errors come back without data; show the
                                // generic failure rather than nothing at all.
                                const responseData = (error.responseJSON && error.responseJSON.data) || {
                                    errorClass: 'send-failed',
                                };
                                if (responseData.errorClass) {
                                    showFormMessage(responseData.errorClass);
                                }
                            });
                    });
                },
            });
        };

        setupAnimations();
    };

    const setupAnimations = () => {
        const buildings = $('.login-city');
        const sunshine = $('.login-sunshine');
        const clouds = $('.login-clouds');

        gsap.to(buildings, {
            backgroundPosition: '-4000px center',
            duration: 600,
            repeat: '-1',
            ease: 'none',
            yoyo: true,
        });

        gsap.to(sunshine, {
            repeat: '-1',
            ease: 'none',
            duration: 90,
            rotation: 360,
            transformOrigin: '180px 190px',
        });

        gsap.to(clouds, {
            y: '+=25',
            x: '-=15',
            repeat: '-1',
            duration: 20,
            yoyo: true,
        });
    };

    return prelogin;
}(Prelogin || {}));
